export enum PartnerCode {
  /**
   * underscored, because can't start an enum member name with a number
   */
  _3P = '3P',
  RatnaSagar = 'RS',
  Edmentum = 'ED',
  Bonding = 'BO',
}
